"use strict";
exports.__esModule = true;
function jsonQueryStringify(query) {
    if (query !== null && typeof query === "object") {
        if ("toJSON" in query) {
            return encodeURIComponent(JSON.stringify(query));
        }
        else if (arrayLike(query)) {
            var json = "[";
            var first = true;
            for (var i = 0; i < query.length; i++) {
                if (first) {
                    first = false;
                }
                else {
                    json += ",";
                }
                json += jsonQueryStringify(query[i]);
            }
            json += "]";
            return json;
        }
        else {
            var json = "{";
            var first = true;
            for (var property in query) {
                if (query.hasOwnProperty(property)) {
                    if (first) {
                        first = false;
                    }
                    else {
                        json += "&";
                    }
                    var value = query[property];
                    json += encodeURIComponent(quotePropertyIfNecessary(property)) + "=" + jsonQueryStringify(value);
                }
            }
            json += "}";
            return json;
        }
    }
    else
        return encodeURIComponent(JSON.stringify(query));
}
exports.jsonQueryStringify = jsonQueryStringify;
function jsonQueryParse(json) {
    json = decodeURIComponent(json);
    var index = 0;
    function consumeQuotedPropertyName() {
        var name = "\"";
        //Skip quote
        index += 1;
        while (json[index] != '"') {
            name += json[index];
            if (json[index] == '\\') {
                index += 1;
                name += json[index];
            }
            index += 1;
        }
        //Skip end quote
        index += 1;
        name += "\"";
        return JSON.parse(name);
    }
    function consumePropertyName() {
        var name = "";
        while (json[index] != "=") {
            name += json[index];
            index += 1;
        }
        return name;
    }
    function consume() {
        var character = json[index];
        index += 1;
        if (character == "[") {
            var result = [];
            while (json[index] != "]") {
                result.push(consume());
                if (json[index] == ",")
                    index += 1;
            }
            index += 1;
            return result;
        }
        else if (character == "{") {
            var result = {};
            while (json[index] != "}") {
                var propertyName = void 0;
                if (json[index] == '"') {
                    propertyName = consumeQuotedPropertyName();
                }
                else {
                    propertyName = consumePropertyName();
                }
                //Consume equals
                index += 1;
                //Consume value
                result[propertyName] = consume();
                if (json[index] == "&") {
                    index += 1;
                }
            }
            index += 1;
            return result;
        }
        else if (character == '"') {
            var str = '"';
            while (json[index] != '"') {
                str += json[index];
                if (json[index] == '\\') {
                    index += 1;
                    str += json[index];
                }
                index += 1;
            }
            str += '"';
            index += 1;
            return JSON.parse(str);
        }
        else if (character == 't') {
            index += 3;
            return true;
        }
        else if (character == 'n') {
            index += 3;
            return null;
        }
        else if (character == 'f') {
            index += 4;
            return false;
        }
        else if (character == 'u') {
            index += 8;
            return undefined;
        }
        else if (isNumericDeclarationStart.test(character)) {
            var number = character;
            while (isNumericDeclarationCharacter.test(json[index])) {
                number += json[index];
                index += 1;
            }
            return JSON.parse(number);
        }
        else {
            throw new Error("Not expecting '" + character + "'");
        }
    }
    return consume();
}
exports.jsonQueryParse = jsonQueryParse;
function jsonQueryStringifyObjectBare(query) {
    var result = jsonQueryStringify(query);
    return result.substring(1, result.length - 1);
}
exports.jsonQueryStringifyObjectBare = jsonQueryStringifyObjectBare;
function jsonQueryParseObjectBare(json) {
    return jsonQueryParse("{" + json + "}");
}
exports.jsonQueryParseObjectBare = jsonQueryParseObjectBare;
var quotesNecessary = /^"|[=]/;
function quotePropertyIfNecessary(str) {
    if (quotesNecessary.test(str)) {
        return JSON.stringify(str);
    }
    else {
        return str;
    }
}
var isNumericDeclarationCharacter = /[\deE+\-.]/;
var isNumericDeclarationStart = /[\-\d]/;
var isInteger = /\d+/;
function arrayLike(obj) {
    if (!("length" in obj)) {
        return false;
    }
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            if (prop !== "length" && !isInteger.test(prop)) {
                return false;
            }
        }
    }
    return true;
}
